"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PK = void 0;
exports.PK = {
    numericCode: '586',
    alpha2Code: 'PK',
    alpha3Code: 'PAK',
    englishName: {
        short: 'Pakistan',
        full: 'the Islamic Republic of Pakistan',
    },
    names: {
        full: {
            en: 'the Islamic Republic of Pakistan',
            fr: 'la République islamique du Pakistan',
            ur: 'Pākistān',
        },
        short: {
            en: 'Pakistan',
            fr: 'Pakistan (le)',
            ur: 'Pākistān',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'ur',
            languageAlpha3Code: 'urd',
            isAdministrative: true,
        },
    ],
    subdivisions: {
        'PK-GB': {
            numericCode: '586',
            code: 'PK-GB',
            category: {
                id: '138',
                names: {
                    en: {
                        singular: 'Pakistan administered area',
                        plural: 'Pakistan administered areas',
                    },
                    fr: {
                        singular: 'zone administrée par le Pakistan',
                        plural: '',
                    },
                    ur: {
                        singular: 'Pakistan kay zair-i-intezam ilaqay',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Gilgit-Baltistan',
                ur: 'Gilgit-Baltistān',
            },
        },
        'PK-JK': {
            numericCode: '586',
            code: 'PK-JK',
            category: {
                id: '138',
                names: {
                    en: {
                        singular: 'Pakistan administered area',
                        plural: 'Pakistan administered areas',
                    },
                    fr: {
                        singular: 'zone administrée par le Pakistan',
                        plural: '',
                    },
                    ur: {
                        singular: 'Pakistan kay zair-i-intezam ilaqay',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Azad Jammu and Kashmir',
                ur: 'Āzād Jammūñ o Kashmīr',
            },
        },
        'PK-IS': {
            numericCode: '586',
            code: 'PK-IS',
            category: {
                id: '191',
                names: {
                    en: {
                        singular: 'federal capital territory',
                        plural: 'federal capital territories',
                    },
                    fr: {
                        singular: 'territoire de la capitale fédérale',
                        plural: '',
                    },
                    ur: {
                        singular: 'wafāqī dār al ḩikūmat ‘alāqah',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Islamabad',
                ur: 'Islāmābād',
            },
        },
        'PK-BA': {
            numericCode: '586',
            code: 'PK-BA',
            category: {
                id: '261',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    ur: {
                        singular: 'sūbah',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Balochistan',
                ur: 'Balōchistān',
            },
        },
        'PK-KP': {
            numericCode: '586',
            code: 'PK-KP',
            category: {
                id: '261',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    ur: {
                        singular: 'sūbah',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Khyber Pakhtunkhwa',
                ur: 'Khaībar Pakhtūnkhwā',
            },
        },
        'PK-PB': {
            numericCode: '586',
            code: 'PK-PB',
            category: {
                id: '261',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    ur: {
                        singular: 'sūbah',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Punjab',
                ur: 'Panjāb',
            },
        },
        'PK-SD': {
            numericCode: '586',
            code: 'PK-SD',
            category: {
                id: '261',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    ur: {
                        singular: 'sūbah',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Sindh',
                ur: 'Sindh',
            },
        },
    },
    cities: [
        {
            name: 'Chuhar Jamāli',
            subdivision: 'Sindh',
        },
        {
            name: 'Rāwala Kot',
            subdivision: 'Azad Kashmir',
        },
        {
            name: 'Pīr jo Goth',
            subdivision: 'Sindh',
        },
        {
            name: 'Khairpur',
            subdivision: 'Sindh',
        },
        {
            name: 'Zhob',
            subdivision: 'Balochistān',
        },
        {
            name: 'Zaida',
            subdivision: 'Khyber Pakhtunkhwa',
        },
        {
            name: 'Zāhir Pīr',
            subdivision: 'Punjab',
        },
        {
            name: 'Zafarwāl',
            subdivision: 'Punjab',
        },
        {
            name: 'Yazman',
            subdivision: 'Punjab',
        },
        {
            name: 'Wazīrābād',
            subdivision: 'Punjab',
        },
        {
            name: 'Warburton',
            subdivision: 'Punjab',
        },
        {
            name: 'Wārāh',
            subdivision: 'Sindh',
        },
        {
            name: 'Vihāri',
            subdivision: 'Punjab',
        },
        {
            name: 'Utmānzai',
            subdivision: 'Khyber Pakhtunkhwa',
        },
        {
            name: 'Uthal',
            subdivision: 'Balochistān',
        },
        {
            name: 'Usta Muhammad',
            subdivision: 'Balochistān',
        },
        {
            name: 'Umarkot',
            subdivision: 'Sindh',
        },
        {
            name: 'Ubauro',
            subdivision: 'Sindh',
        },
        {
            name: 'Turbat',
            subdivision: 'Balochistān',
        },
        {
            name: 'Topi',
            subdivision: 'Khyber Pakhtunkhwa',
        },
        {
            name: 'Toba Tek Singh',
            subdivision: 'Punjab',
        },
        {
            name: 'Thul',
            subdivision: 'Sindh',
        },
        {
            name: 'Thatta',
            subdivision: 'Sindh',
        },
        {
            name: 'Thāru Shāh',
            subdivision: 'Sindh',
        },
        {
            name: 'Taunsa',
            subdivision: 'Punjab',
        },
        {
            name: 'Tānk',
            subdivision: 'Khyber Pakhtunkhwa',
        },
        {
            name: 'Tangi',
            subdivision: 'Khyber Pakhtunkhwa',
        },
        {
            name: 'Tando Muhammad Khān',
            subdivision: 'Sindh',
        },
        {
            name: 'Tando Jām',
            subdivision: 'Sindh',
        },
        {
            name: 'Tando Allāhyār',
            subdivision: 'Sindh',
        },
        {
            name: 'Tando Ādam',
            subdivision: 'Sindh',
        },
        {
            name: 'Tāndliānwāla',
            subdivision: 'Punjab',
        },
        {
            name: 'Talhār',
            subdivision: 'Sindh',
        },
        {
            name: 'Talamba',
            subdivision: 'Punjab',
        },
        {
            name: 'Talagang',
            subdivision: 'Punjab',
        },
        {
            name: 'Tāl',
            subdivision: 'Khyber Pakhtunkhwa',
        },
        {
            name: 'Swābi',
            subdivision: 'Khyber Pakhtunkhwa',
        },
        {
            name: 'Surkhpur',
            subdivision: 'Punjab',
        },
        {
            name: 'Sukkur',
            subdivision: 'Sindh',
        },
        {
            name: 'Sukheke Mandi',
            subdivision: 'Punjab',
        },
        {
            name: 'Sodhra',
            subdivision: 'Punjab',
        },
        {
            name: 'Sīta Road',
            subdivision: 'Sindh',
        },
        {
            name: 'Sinjhoro',
            subdivision: 'Sindh',
        },
        {
            name: 'Sillānwāli',
            subdivision: 'Punjab',
        },
        {
            name: 'Sibi',
            subdivision: 'Balochistān',
        },
        {
            name: 'Sialkot',
            subdivision: 'Punjab',
        },
        {
            name: 'Shujāābād',
            subdivision: 'Punjab',
        },
        {
            name: 'Shorko',
            subdivision: 'Khyber Pakhtunkhwa',
        },
        {
            name: 'Shikārpur',
            subdivision: 'Sindh',
        },
        {
            name: 'Sheikhupura',
            subdivision: 'Punjab',
        },
        {
            name: 'Sharqpur',
            subdivision: 'Punjab',
        },
        {
            name: 'Shakargarr',
            subdivision: 'Punjab',
        },
        {
            name: 'Shahr Sultān',
            subdivision: 'Punjab',
        },
        {
            name: 'Shāhpur Chākar',
            subdivision: 'Sindh',
        },
        {
            name: 'Shahkot',
            subdivision: 'Punjab',
        },
        {
            name: 'Shāhdādpur',
            subdivision: 'Sindh',
        },
        {
            name: 'Shāhdādkot',
            subdivision: 'Sindh',
        },
        {
            name: 'Shabqadar',
            subdivision: 'Khyber Pakhtunkhwa',
        },
        {
            name: 'Sehwān',
            subdivision: 'Sindh',
        },
        {
            name: 'Sargodha',
            subdivision: 'Punjab',
        },
        {
            name: 'Sarāi Sidhu',
            subdivision: 'Punjab',
        },
        {
            name: 'Sarāi Naurang',
            subdivision: 'Khyber Pakhtunkhwa',
        },
        {
            name: 'Sarāi Ālamgīr',
            subdivision: 'Punjab',
        },
        {
            name: 'Sangla Hill',
            subdivision: 'Punjab',
        },
        {
            name: 'Sānghar',
            subdivision: 'Sindh',
        },
        {
            name: 'Sambriāl',
            subdivision: 'Punjab',
        },
        {
            name: 'Sakrand',
            subdivision: 'Sindh',
        },
        {
            name: 'Sāhīwāl',
            subdivision: 'Punjab',
        },
        {
            name: 'Sahiwal',
            subdivision: 'Punjab',
        },
        {
            name: 'Sādiqābād',
            subdivision: 'Punjab',
        },
        {
            name: 'Rohri',
            subdivision: 'Sindh',
        },
        {
            name: 'Renāla Khurd',
            subdivision: 'Punjab',
        },
        {
            name: 'Rawalpindi',
            subdivision: 'Punjab',
        },
        {
            name: 'Ratodero',
            subdivision: 'Sindh',
        },
        {
            name: 'Rānīpur',
            subdivision: 'Sindh',
        },
        {
            name: 'Rājanpur',
            subdivision: 'Punjab',
        },
        {
            name: 'Rāja Jang',
            subdivision: 'Punjab',
        },
        {
            name: 'Rāiwind',
            subdivision: 'Punjab',
        },
        {
            name: 'Rādhan',
            subdivision: 'Sindh',
        },
        {
            name: 'Rabwāh',
            subdivision: 'Punjab',
        },
        {
            name: 'Quetta',
            subdivision: 'Balochistān',
        },
        {
            name: 'Kambar',
            subdivision: 'Sindh',
        },
        {
            name: 'Qādirpur Rān',
            subdivision: 'Punjab',
        },
        {
            name: 'Pishin',
            subdivision: 'Balochistān',
        },
        {
            name: 'Pīr Mahal',
            subdivision: 'Punjab',
        },
        {
            name: 'Pindi Gheb',
            subdivision: 'Punjab',
        },
        {
            name: 'Pindi Bhattiān',
            subdivision: 'Punjab',
        },
        {
            name: 'Pind Dādan Khān',
            subdivision: 'Punjab',
        },
        {
            name: 'Phālia',
            subdivision: 'Punjab',
        },
        {
            name: 'Peshawar',
            subdivision: 'Khyber Pakhtunkhwa',
        },
        {
            name: 'Pattoki',
            subdivision: 'Punjab',
        },
        {
            name: 'Pasrūr',
            subdivision: 'Punjab',
        },
        {
            name: 'Pasni',
            subdivision: 'Balochistān',
        },
        {
            name: 'Pāno Āqil',
            subdivision: 'Sindh',
        },
        {
            name: 'Pākpattan',
            subdivision: 'Punjab',
        },
        {
            name: 'Pahārpur',
            subdivision: 'Khyber Pakhtunkhwa',
        },
        {
            name: 'Pad Īdan',
            subdivision: 'Sindh',
        },
        {
            name: 'Pabbi',
            subdivision: 'Khyber Pakhtunkhwa',
        },
        {
            name: 'Okāra',
            subdivision: 'Punjab',
        },
        {
            name: 'Nushki',
            subdivision: 'Balochistān',
        },
        {
            name: 'Nawābshāh',
            subdivision: 'Sindh',
        },
        {
            name: 'Naushahro Fīroz',
            subdivision: 'Sindh',
        },
        {
            name: 'Naushahra Virkān',
            subdivision: 'Punjab',
        },
        {
            name: 'Naudero',
            subdivision: 'Sindh',
        },
        {
            name: 'Nasīrābād',
            subdivision: 'Sindh',
        },
        {
            name: 'Nārowāl',
            subdivision: 'Punjab',
        },
        {
            name: 'Nārang',
            subdivision: 'Punjab',
        },
        {
            name: 'Naukot',
            subdivision: 'Sindh',
        },
        {
            name: 'Nankāna Sāhib',
            subdivision: 'Punjab',
        },
        {
            name: 'Muzaffargarh',
            subdivision: 'Punjab',
        },
        {
            name: 'Muzaffarābād',
            subdivision: 'Azad Kashmir',
        },
        {
            name: 'Mustafābād',
            subdivision: 'Punjab',
        },
        {
            name: 'Murree',
            subdivision: 'Punjab',
        },
        {
            name: 'Murīdke',
            subdivision: 'Punjab',
        },
        {
            name: 'Multān',
            subdivision: 'Punjab',
        },
        {
            name: 'Moro',
            subdivision: 'Sindh',
        },
        {
            name: 'Mithi',
            subdivision: 'Sindh',
        },
        {
            name: 'Mitha Tiwāna',
            subdivision: 'Punjab',
        },
        {
            name: 'Mīrpur Māthelo',
            subdivision: 'Sindh',
        },
        {
            name: 'Mirpur Khas',
            subdivision: 'Sindh',
        },
        {
            name: 'Mingora',
            subdivision: 'Khyber Pakhtunkhwa',
        },
        {
            name: 'Minchinābād',
            subdivision: 'Punjab',
        },
        {
            name: 'Miānwāli',
            subdivision: 'Punjab',
        },
        {
            name: 'Miān Channūn',
            subdivision: 'Punjab',
        },
        {
            name: 'Mehrābpur',
            subdivision: 'Balochistān',
        },
        {
            name: 'Mehar',
            subdivision: 'Sindh',
        },
        {
            name: 'Mātli',
            subdivision: 'Sindh',
        },
        {
            name: 'Matiāri',
            subdivision: 'Sindh',
        },
        {
            name: 'Mastung',
            subdivision: 'Balochistān',
        },
        {
            name: 'Mardan',
            subdivision: 'Khyber Pakhtunkhwa',
        },
        {
            name: 'Mānsehra',
            subdivision: 'Khyber Pakhtunkhwa',
        },
        {
            name: 'Mangla',
            subdivision: 'Punjab',
        },
        {
            name: 'Mandi Bahāuddīn',
            subdivision: 'Punjab',
        },
        {
            name: 'Mānānwāla',
            subdivision: 'Punjab',
        },
        {
            name: 'Māmu Kānjan',
            subdivision: 'Punjab',
        },
        {
            name: 'Malir Cantonment',
            subdivision: 'Sindh',
        },
        {
            name: 'Malakwāl',
            subdivision: 'Punjab',
        },
        {
            name: 'Mailsi',
            subdivision: 'Punjab',
        },
        {
            name: 'Mach',
            subdivision: 'Balochistān',
        },
        {
            name: 'Loralai',
            subdivision: 'Balochistān',
        },
        {
            name: 'Lodhrān',
            subdivision: 'Punjab',
        },
        {
            name: 'Layyah',
            subdivision: 'Punjab',
        },
        {
            name: 'Lārkāna',
            subdivision: 'Sindh',
        },
        {
            name: 'Lāliān',
            subdivision: 'Punjab',
        },
        {
            name: 'Lāla Mūsa',
            subdivision: 'Punjab',
        },
        {
            name: 'Lakki Marwat',
            subdivision: 'Khyber Pakhtunkhwa',
        },
        {
            name: 'Lahore',
            subdivision: 'Punjab',
        },
        {
            name: 'Ladhewāla Warāich',
            subdivision: 'Punjab',
        },
        {
            name: 'Lāchi',
            subdivision: 'Khyber Pakhtunkhwa',
        },
        {
            name: 'Kunri',
            subdivision: 'Sindh',
        },
        {
            name: 'Kunjāh',
            subdivision: 'Punjab',
        },
        {
            name: 'Kundiān',
            subdivision: 'Punjab',
        },
        {
            name: 'Kulāchi',
            subdivision: 'Khyber Pakhtunkhwa',
        },
        {
            name: 'Kot Samāba',
            subdivision: 'Punjab',
        },
        {
            name: 'Kotri',
            subdivision: 'Sindh',
        },
        {
            name: 'Kot Rādha Kishan',
            subdivision: 'Punjab',
        },
        {
            name: 'Kot Mūmin',
            subdivision: 'Punjab',
        },
        {
            name: 'Kot Malik',
            subdivision: 'Balochistān',
        },
        {
            name: 'Kotli Lohārān',
            subdivision: 'Punjab',
        },
        {
            name: 'Kotli',
            subdivision: 'Azad Kashmir',
        },
        {
            name: 'Kot Ghulām Muhammad',
            subdivision: 'Punjab',
        },
        {
            name: 'Kot Diji',
            subdivision: 'Sindh',
        },
        {
            name: 'Kot Addu',
            subdivision: 'Punjab',
        },
        {
            name: 'Kohāt',
            subdivision: 'Khyber Pakhtunkhwa',
        },
        {
            name: 'Khushāb',
            subdivision: 'Punjab',
        },
        {
            name: 'Khurriānwāla',
            subdivision: 'Punjab',
        },
        {
            name: 'Khewra',
            subdivision: 'Punjab',
        },
        {
            name: 'Khāriān',
            subdivision: 'Punjab',
        },
        {
            name: 'Khārān',
            subdivision: 'Balochistān',
        },
        {
            name: 'Khānpur',
            subdivision: 'Punjab',
        },
        {
            name: 'Khānpur',
            subdivision: 'Sindh',
        },
        {
            name: 'Khāngarh',
            subdivision: 'Punjab',
        },
        {
            name: 'Khāngāh Dogrān',
            subdivision: 'Punjab',
        },
        {
            name: 'Khalābat',
            subdivision: 'Khyber Pakhtunkhwa',
        },
        {
            name: 'Khairpur Nathan Shāh',
            subdivision: 'Sindh',
        },
        {
            name: 'Khairpur',
            subdivision: 'Punjab',
        },
        {
            name: 'Khairpur',
            subdivision: 'Sindh',
        },
        {
            name: 'Kasūr',
            subdivision: 'Punjab',
        },
        {
            name: 'Kashmor',
            subdivision: 'Sindh',
        },
        {
            name: 'Karor',
            subdivision: 'Punjab',
        },
        {
            name: 'Karachi',
            subdivision: 'Sindh',
        },
        {
            name: 'Kanganpur',
            subdivision: 'Punjab',
        },
        {
            name: 'Kandiāro',
            subdivision: 'Sindh',
        },
        {
            name: 'Kandhkot',
            subdivision: 'Sindh',
        },
        {
            name: 'Kāmra',
            subdivision: 'Punjab',
        },
        {
            name: 'Kamoke',
            subdivision: 'Punjab',
        },
        {
            name: 'Kamīr',
            subdivision: 'Punjab',
        },
        {
            name: 'Kamar Mushāni',
            subdivision: 'Punjab',
        },
        {
            name: 'Kamālia',
            subdivision: 'Punjab',
        },
        {
            name: 'Kalūr Kot',
            subdivision: 'Punjab',
        },
        {
            name: 'Kallar Kahār',
            subdivision: 'Punjab',
        },
        {
            name: 'Kāleke Mandi',
            subdivision: 'Punjab',
        },
        {
            name: 'Kalāt',
            subdivision: 'Balochistān',
        },
        {
            name: 'Kālābāgh',
            subdivision: 'Punjab',
        },
        {
            name: 'Kahūta',
            subdivision: 'Punjab',
        },
        {
            name: 'Kohror Pakka',
            subdivision: 'Punjab',
        },
        {
            name: 'Kāhna',
            subdivision: 'Punjab',
        },
        {
            name: 'Kabīrwāla',
            subdivision: 'Punjab',
        },
        {
            name: 'Johi',
            subdivision: 'Sindh',
        },
        {
            name: 'Jīwani',
            subdivision: 'Balochistān',
        },
        {
            name: 'Jhumra',
            subdivision: 'Punjab',
        },
        {
            name: 'Jhol',
            subdivision: 'Sindh',
        },
        {
            name: 'Jhelum',
            subdivision: 'Punjab',
        },
        {
            name: 'Jhawāriān',
            subdivision: 'Punjab',
        },
        {
            name: 'Jhang Sadr',
            subdivision: 'Punjab',
        },
        {
            name: 'Jauharābād',
            subdivision: 'Punjab',
        },
        {
            name: 'Jatoi Shimāli',
            subdivision: 'Punjab',
        },
        {
            name: 'Jarānwāla',
            subdivision: 'Punjab',
        },
        {
            name: 'Jand',
            subdivision: 'Punjab',
        },
        {
            name: 'Jāmpur',
            subdivision: 'Punjab',
        },
        {
            name: 'Jalālpur Pīrwāla',
            subdivision: 'Punjab',
        },
        {
            name: 'Jalālpur',
            subdivision: 'Punjab',
        },
        {
            name: 'Jahāniān Shāh',
            subdivision: 'Punjab',
        },
        {
            name: 'Jacobābād',
            subdivision: 'Sindh',
        },
        {
            name: 'Islamabad',
            subdivision: 'Islāmābād',
        },
        {
            name: 'Hyderabad',
            subdivision: 'Sindh',
        },
        {
            name: 'Hujra',
            subdivision: 'Punjab',
        },
        {
            name: 'Hingorja',
            subdivision: 'Sindh',
        },
        {
            name: 'Hazro',
            subdivision: 'Punjab',
        },
        {
            name: 'Haveliān',
            subdivision: 'Khyber Pakhtunkhwa',
        },
        {
            name: 'Haveli',
            subdivision: 'Punjab',
        },
        {
            name: 'Hāsilpur',
            subdivision: 'Punjab',
        },
        {
            name: 'Hasan Abdāl',
            subdivision: 'Punjab',
        },
        {
            name: 'Haru Zbad',
            subdivision: 'Punjab',
        },
        {
            name: 'Harnoli',
            subdivision: 'Punjab',
        },
        {
            name: 'Harīpur',
            subdivision: 'Khyber Pakhtunkhwa',
        },
        {
            name: 'Hangu',
            subdivision: 'Khyber Pakhtunkhwa',
        },
        {
            name: 'Hāla',
            subdivision: 'Sindh',
        },
        {
            name: 'Hāfizābād',
            subdivision: 'Punjab',
        },
        {
            name: 'Hadāli',
            subdivision: 'Punjab',
        },
        {
            name: 'Gwadar',
            subdivision: 'Balochistān',
        },
        {
            name: 'Gujrāt',
            subdivision: 'Punjab',
        },
        {
            name: 'Gujrānwāla',
            subdivision: 'Punjab',
        },
        {
            name: 'Gūjar Khān',
            subdivision: 'Punjab',
        },
        {
            name: 'Gojra',
            subdivision: 'Punjab',
        },
        {
            name: 'Ghotki',
            subdivision: 'Sindh',
        },
        {
            name: 'Ghauspur',
            subdivision: 'Sindh',
        },
        {
            name: 'Ghāro',
            subdivision: 'Sindh',
        },
        {
            name: 'Garh Mahārāja',
            subdivision: 'Punjab',
        },
        {
            name: 'Gambat',
            subdivision: 'Sindh',
        },
        {
            name: 'Fort Abbās',
            subdivision: 'Punjab',
        },
        {
            name: 'Fazalpur',
            subdivision: 'Punjab',
        },
        {
            name: 'Chak Two Hundred Forty-Nine TDA',
            subdivision: 'Punjab',
        },
        {
            name: 'Faruka',
            subdivision: 'Punjab',
        },
        {
            name: 'Faqīrwāli',
            subdivision: 'Punjab',
        },
        {
            name: 'Faisalābād',
            subdivision: 'Punjab',
        },
        {
            name: 'Eminābād',
            subdivision: 'Punjab',
        },
        {
            name: 'Dunyāpur',
            subdivision: 'Punjab',
        },
        {
            name: 'Dunga Bunga',
            subdivision: 'Punjab',
        },
        {
            name: 'Dullewāla',
            subdivision: 'Punjab',
        },
        {
            name: 'Dīr',
            subdivision: 'Khyber Pakhtunkhwa',
        },
        {
            name: 'Dīpālpur',
            subdivision: 'Punjab',
        },
        {
            name: 'Dinga',
            subdivision: 'Punjab',
        },
        {
            name: 'Dijkot',
            subdivision: 'Punjab',
        },
        {
            name: 'Digri',
            subdivision: 'Sindh',
        },
        {
            name: 'Dhoro Naro',
            subdivision: 'Sindh',
        },
        {
            name: 'Dhanot',
            subdivision: 'Punjab',
        },
        {
            name: 'Dera Ismāīl Khān',
            subdivision: 'Khyber Pakhtunkhwa',
        },
        {
            name: 'Dera Ghazi Khan',
            subdivision: 'Punjab',
        },
        {
            name: 'Dera Bugti',
            subdivision: 'Balochistān',
        },
        {
            name: 'Daur',
            subdivision: 'Sindh',
        },
        {
            name: 'Dāūd Khel',
            subdivision: 'Punjab',
        },
        {
            name: 'Daska',
            subdivision: 'Punjab',
        },
        {
            name: 'Darya Khān',
            subdivision: 'Punjab',
        },
        {
            name: 'Dājal',
            subdivision: 'Punjab',
        },
        {
            name: 'Dadu',
            subdivision: 'Sindh',
        },
        {
            name: 'Dādhar',
            subdivision: 'Balochistān',
        },
        {
            name: 'Chūniān',
            subdivision: 'Punjab',
        },
        {
            name: 'Chūhar Kāna',
            subdivision: 'Punjab',
        },
        {
            name: 'Chor',
            subdivision: 'Sindh',
        },
        {
            name: 'Choa Saidān Shāh',
            subdivision: 'Punjab',
        },
        {
            name: 'Chishtiān Mandi',
            subdivision: 'Punjab',
        },
        {
            name: 'Chiniot',
            subdivision: 'Punjab',
        },
        {
            name: 'Chīchāwatni',
            subdivision: 'Punjab',
        },
        {
            name: 'Chawinda',
            subdivision: 'Punjab',
        },
        {
            name: 'Charsadda',
            subdivision: 'Khyber Pakhtunkhwa',
        },
        {
            name: 'Chaman',
            subdivision: 'Balochistān',
        },
        {
            name: 'Chakwāl',
            subdivision: 'Punjab',
        },
        {
            name: 'Chak Āzam Saffo',
            subdivision: 'Punjab',
        },
        {
            name: 'Būrewāla',
            subdivision: 'Punjab',
        },
        {
            name: 'Bhopālwāla',
            subdivision: 'Punjab',
        },
        {
            name: 'Bhit Shāh',
            subdivision: 'Sindh',
        },
        {
            name: 'Bhimbar',
            subdivision: 'Azad Kashmir',
        },
        {
            name: 'Bhera',
            subdivision: 'Punjab',
        },
        {
            name: 'Bhawāna',
            subdivision: 'Punjab',
        },
        {
            name: 'Bhān',
            subdivision: 'Sindh',
        },
        {
            name: 'Bhalwāl',
            subdivision: 'Punjab',
        },
        {
            name: 'Bhakkar',
            subdivision: 'Punjab',
        },
        {
            name: 'Bhāi Pheru',
            subdivision: 'Punjab',
        },
        {
            name: 'Bela',
            subdivision: 'Balochistān',
        },
        {
            name: 'Bat Khela',
            subdivision: 'Khyber Pakhtunkhwa',
        },
        {
            name: 'Basīrpur',
            subdivision: 'Punjab',
        },
        {
            name: 'Bannu',
            subdivision: 'Khyber Pakhtunkhwa',
        },
        {
            name: 'Bahāwalpur',
            subdivision: 'Punjab',
        },
        {
            name: 'Bahāwalnagar',
            subdivision: 'Punjab',
        },
        {
            name: 'Badīn',
            subdivision: 'Sindh',
        },
        {
            name: 'Baddomalhi',
            subdivision: 'Punjab',
        },
        {
            name: 'Attock City',
            subdivision: 'Punjab',
        },
        {
            name: 'Ārifwāla',
            subdivision: 'Punjab',
        },
        {
            name: 'Amangarh',
            subdivision: 'Khyber Pakhtunkhwa',
        },
        {
            name: 'Alīpur',
            subdivision: 'Punjab',
        },
        {
            name: 'Akora',
            subdivision: 'Khyber Pakhtunkhwa',
        },
        {
            name: 'Ahmadpur East',
            subdivision: 'Punjab',
        },
        {
            name: 'Abbottābād',
            subdivision: 'Khyber Pakhtunkhwa',
        },
        {
            name: 'Bahāwalnagar',
            subdivision: 'Punjab',
        },
        {
            name: 'Nowshera Cantonment',
            subdivision: 'Khyber Pakhtunkhwa',
        },
        {
            name: 'Ahmadpur Siāl',
            subdivision: 'Punjab',
        },
        {
            name: 'New Bādāh',
            subdivision: 'Sindh',
        },
        {
            name: 'Tando Ghulām Ali',
            subdivision: 'Sindh',
        },
        {
            name: 'Sethārja Old',
            subdivision: 'Sindh',
        },
        {
            name: 'Risālpur',
            subdivision: 'Khyber Pakhtunkhwa',
        },
        {
            name: 'Malakwal City',
            subdivision: 'Punjab',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUEsuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY291bnRyaWVzL2RhdGEvUEsudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7O0dBSUc7OztBQU1VLFFBQUEsRUFBRSxHQUFZO0lBQ3ZCLFdBQVcsRUFBRSxLQUFLO0lBQ2xCLFVBQVUsRUFBRSxJQUFJO0lBQ2hCLFVBQVUsRUFBRSxLQUFLO0lBQ2pCLFdBQVcsRUFBRTtRQUNULEtBQUssRUFBRSxVQUFVO1FBQ2pCLElBQUksRUFBRSxrQ0FBa0M7S0FDM0M7SUFDRCxLQUFLLEVBQUU7UUFDSCxJQUFJLEVBQUU7WUFDRixFQUFFLEVBQUUsa0NBQWtDO1lBQ3RDLEVBQUUsRUFBRSxxQ0FBcUM7WUFDekMsRUFBRSxFQUFFLFVBQVU7U0FDakI7UUFDRCxLQUFLLEVBQUU7WUFDSCxFQUFFLEVBQUUsVUFBVTtZQUNkLEVBQUUsRUFBRSxlQUFlO1lBQ25CLEVBQUUsRUFBRSxVQUFVO1NBQ2pCO0tBQ0o7SUFDRCxTQUFTLEVBQUU7UUFDUDtZQUNJLGtCQUFrQixFQUFFLElBQUk7WUFDeEIsa0JBQWtCLEVBQUUsS0FBSztZQUN6QixnQkFBZ0IsRUFBRSxJQUFJO1NBQ3pCO1FBQ0Q7WUFDSSxrQkFBa0IsRUFBRSxJQUFJO1lBQ3hCLGtCQUFrQixFQUFFLEtBQUs7WUFDekIsZ0JBQWdCLEVBQUUsS0FBSztTQUMxQjtRQUNEO1lBQ0ksa0JBQWtCLEVBQUUsSUFBSTtZQUN4QixrQkFBa0IsRUFBRSxLQUFLO1lBQ3pCLGdCQUFnQixFQUFFLElBQUk7U0FDekI7S0FDSjtJQUNELFlBQVksRUFBRTtRQUNWLE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLDRCQUE0Qjt3QkFDdEMsTUFBTSxFQUFFLDZCQUE2QjtxQkFDeEM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxrQ0FBa0M7d0JBQzVDLE1BQU0sRUFBRSxFQUFFO3FCQUNiO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsb0NBQW9DO3dCQUM5QyxNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGtCQUFrQjtnQkFDdEIsRUFBRSxFQUFFLGtCQUFrQjthQUN6QjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsNEJBQTRCO3dCQUN0QyxNQUFNLEVBQUUsNkJBQTZCO3FCQUN4QztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGtDQUFrQzt3QkFDNUMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxvQ0FBb0M7d0JBQzlDLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsd0JBQXdCO2dCQUM1QixFQUFFLEVBQUUsdUJBQXVCO2FBQzlCO1NBQ0o7UUFDRCxPQUFPLEVBQUU7WUFDTCxXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsT0FBTztZQUNiLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSwyQkFBMkI7d0JBQ3JDLE1BQU0sRUFBRSw2QkFBNkI7cUJBQ3hDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsb0NBQW9DO3dCQUM5QyxNQUFNLEVBQUUsRUFBRTtxQkFDYjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLCtCQUErQjt3QkFDekMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxXQUFXO2dCQUNmLEVBQUUsRUFBRSxXQUFXO2FBQ2xCO1NBQ0o7UUFDRCxPQUFPLEVBQUU7WUFDTCxXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsT0FBTztZQUNiLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxVQUFVO3dCQUNwQixNQUFNLEVBQUUsV0FBVztxQkFDdEI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxVQUFVO3dCQUNwQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE9BQU87d0JBQ2pCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsYUFBYTtnQkFDakIsRUFBRSxFQUFFLGFBQWE7YUFDcEI7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFVBQVU7d0JBQ3BCLE1BQU0sRUFBRSxXQUFXO3FCQUN0QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFVBQVU7d0JBQ3BCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsT0FBTzt3QkFDakIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxvQkFBb0I7Z0JBQ3hCLEVBQUUsRUFBRSxxQkFBcUI7YUFDNUI7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFVBQVU7d0JBQ3BCLE1BQU0sRUFBRSxXQUFXO3FCQUN0QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFVBQVU7d0JBQ3BCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsT0FBTzt3QkFDakIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxRQUFRO2dCQUNaLEVBQUUsRUFBRSxRQUFRO2FBQ2Y7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFVBQVU7d0JBQ3BCLE1BQU0sRUFBRSxXQUFXO3FCQUN0QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFVBQVU7d0JBQ3BCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsT0FBTzt3QkFDakIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxPQUFPO2dCQUNYLEVBQUUsRUFBRSxPQUFPO2FBQ2Q7U0FDSjtLQUNKO0lBQ0QsTUFBTSxFQUFFO1FBQ0o7WUFDSSxJQUFJLEVBQUUsZUFBZTtZQUNyQixXQUFXLEVBQUUsT0FBTztTQUN2QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFlBQVk7WUFDbEIsV0FBVyxFQUFFLGNBQWM7U0FDOUI7UUFDRDtZQUNJLElBQUksRUFBRSxhQUFhO1lBQ25CLFdBQVcsRUFBRSxPQUFPO1NBQ3ZCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsVUFBVTtZQUNoQixXQUFXLEVBQUUsT0FBTztTQUN2QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLE1BQU07WUFDWixXQUFXLEVBQUUsYUFBYTtTQUM3QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLE9BQU87WUFDYixXQUFXLEVBQUUsb0JBQW9CO1NBQ3BDO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsV0FBVztZQUNqQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFVBQVU7WUFDaEIsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxRQUFRO1lBQ2QsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxXQUFXO1lBQ2pCLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsV0FBVztZQUNqQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLE9BQU87WUFDYixXQUFXLEVBQUUsT0FBTztTQUN2QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFFBQVE7WUFDZCxXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFVBQVU7WUFDaEIsV0FBVyxFQUFFLG9CQUFvQjtTQUNwQztRQUNEO1lBQ0ksSUFBSSxFQUFFLE9BQU87WUFDYixXQUFXLEVBQUUsYUFBYTtTQUM3QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLGVBQWU7WUFDckIsV0FBVyxFQUFFLGFBQWE7U0FDN0I7UUFDRDtZQUNJLElBQUksRUFBRSxTQUFTO1lBQ2YsV0FBVyxFQUFFLE9BQU87U0FDdkI7UUFDRDtZQUNJLElBQUksRUFBRSxRQUFRO1lBQ2QsV0FBVyxFQUFFLE9BQU87U0FDdkI7UUFDRDtZQUNJLElBQUksRUFBRSxRQUFRO1lBQ2QsV0FBVyxFQUFFLGFBQWE7U0FDN0I7UUFDRDtZQUNJLElBQUksRUFBRSxNQUFNO1lBQ1osV0FBVyxFQUFFLG9CQUFvQjtTQUNwQztRQUNEO1lBQ0ksSUFBSSxFQUFFLGdCQUFnQjtZQUN0QixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLE1BQU07WUFDWixXQUFXLEVBQUUsT0FBTztTQUN2QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFFBQVE7WUFDZCxXQUFXLEVBQUUsT0FBTztTQUN2QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFlBQVk7WUFDbEIsV0FBVyxFQUFFLE9BQU87U0FDdkI7UUFDRDtZQUNJLElBQUksRUFBRSxRQUFRO1lBQ2QsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxNQUFNO1lBQ1osV0FBVyxFQUFFLG9CQUFvQjtTQUNwQztRQUNEO1lBQ0ksSUFBSSxFQUFFLE9BQU87WUFDYixXQUFXLEVBQUUsb0JBQW9CO1NBQ3BDO1FBQ0Q7WUFDSSxJQUFJLEVBQUUscUJBQXFCO1lBQzNCLFdBQVcsRUFBRSxPQUFPO1NBQ3ZCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsV0FBVztZQUNqQixXQUFXLEVBQUUsT0FBTztTQUN2QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLGdCQUFnQjtZQUN0QixXQUFXLEVBQUUsT0FBTztTQUN2QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFlBQVk7WUFDbEIsV0FBVyxFQUFFLE9BQU87U0FDdkI7UUFDRDtZQUNJLElBQUksRUFBRSxjQUFjO1lBQ3BCLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsUUFBUTtZQUNkLFdBQVcsRUFBRSxPQUFPO1NBQ3ZCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsU0FBUztZQUNmLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsVUFBVTtZQUNoQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLEtBQUs7WUFDWCxXQUFXLEVBQUUsb0JBQW9CO1NBQ3BDO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsT0FBTztZQUNiLFdBQVcsRUFBRSxvQkFBb0I7U0FDcEM7UUFDRDtZQUNJLElBQUksRUFBRSxVQUFVO1lBQ2hCLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsUUFBUTtZQUNkLFdBQVcsRUFBRSxPQUFPO1NBQ3ZCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsZUFBZTtZQUNyQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFFBQVE7WUFDZCxXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFdBQVc7WUFDakIsV0FBVyxFQUFFLE9BQU87U0FDdkI7UUFDRDtZQUNJLElBQUksRUFBRSxVQUFVO1lBQ2hCLFdBQVcsRUFBRSxPQUFPO1NBQ3ZCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsWUFBWTtZQUNsQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLE1BQU07WUFDWixXQUFXLEVBQUUsYUFBYTtTQUM3QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFNBQVM7WUFDZixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFdBQVc7WUFDakIsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxRQUFRO1lBQ2QsV0FBVyxFQUFFLG9CQUFvQjtTQUNwQztRQUNEO1lBQ0ksSUFBSSxFQUFFLFdBQVc7WUFDakIsV0FBVyxFQUFFLE9BQU87U0FDdkI7UUFDRDtZQUNJLElBQUksRUFBRSxhQUFhO1lBQ25CLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsVUFBVTtZQUNoQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFlBQVk7WUFDbEIsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxjQUFjO1lBQ3BCLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsZ0JBQWdCO1lBQ3RCLFdBQVcsRUFBRSxPQUFPO1NBQ3ZCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsU0FBUztZQUNmLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsWUFBWTtZQUNsQixXQUFXLEVBQUUsT0FBTztTQUN2QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFlBQVk7WUFDbEIsV0FBVyxFQUFFLE9BQU87U0FDdkI7UUFDRDtZQUNJLElBQUksRUFBRSxXQUFXO1lBQ2pCLFdBQVcsRUFBRSxvQkFBb0I7U0FDcEM7UUFDRDtZQUNJLElBQUksRUFBRSxRQUFRO1lBQ2QsV0FBVyxFQUFFLE9BQU87U0FDdkI7UUFDRDtZQUNJLElBQUksRUFBRSxVQUFVO1lBQ2hCLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsYUFBYTtZQUNuQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLGVBQWU7WUFDckIsV0FBVyxFQUFFLG9CQUFvQjtTQUNwQztRQUNEO1lBQ0ksSUFBSSxFQUFFLGVBQWU7WUFDckIsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxhQUFhO1lBQ25CLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsU0FBUztZQUNmLFdBQVcsRUFBRSxPQUFPO1NBQ3ZCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsVUFBVTtZQUNoQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFNBQVM7WUFDZixXQUFXLEVBQUUsT0FBTztTQUN2QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFNBQVM7WUFDZixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFNBQVM7WUFDZixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFdBQVc7WUFDakIsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxPQUFPO1lBQ2IsV0FBVyxFQUFFLE9BQU87U0FDdkI7UUFDRDtZQUNJLElBQUksRUFBRSxjQUFjO1lBQ3BCLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsWUFBWTtZQUNsQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFVBQVU7WUFDaEIsV0FBVyxFQUFFLE9BQU87U0FDdkI7UUFDRDtZQUNJLElBQUksRUFBRSxTQUFTO1lBQ2YsV0FBVyxFQUFFLE9BQU87U0FDdkI7UUFDRDtZQUNJLElBQUksRUFBRSxVQUFVO1lBQ2hCLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsV0FBVztZQUNqQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFNBQVM7WUFDZixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFFBQVE7WUFDZCxXQUFXLEVBQUUsT0FBTztTQUN2QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFFBQVE7WUFDZCxXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFFBQVE7WUFDZCxXQUFXLEVBQUUsYUFBYTtTQUM3QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFFBQVE7WUFDZCxXQUFXLEVBQUUsT0FBTztTQUN2QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLGNBQWM7WUFDcEIsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxRQUFRO1lBQ2QsV0FBVyxFQUFFLGFBQWE7U0FDN0I7UUFDRDtZQUNJLElBQUksRUFBRSxXQUFXO1lBQ2pCLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsWUFBWTtZQUNsQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLGdCQUFnQjtZQUN0QixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLGlCQUFpQjtZQUN2QixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFFBQVE7WUFDZCxXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFVBQVU7WUFDaEIsV0FBVyxFQUFFLG9CQUFvQjtTQUNwQztRQUNEO1lBQ0ksSUFBSSxFQUFFLFNBQVM7WUFDZixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFFBQVE7WUFDZCxXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLE9BQU87WUFDYixXQUFXLEVBQUUsYUFBYTtTQUM3QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFdBQVc7WUFDakIsV0FBVyxFQUFFLE9BQU87U0FDdkI7UUFDRDtZQUNJLElBQUksRUFBRSxXQUFXO1lBQ2pCLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsVUFBVTtZQUNoQixXQUFXLEVBQUUsb0JBQW9CO1NBQ3BDO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsVUFBVTtZQUNoQixXQUFXLEVBQUUsT0FBTztTQUN2QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLE9BQU87WUFDYixXQUFXLEVBQUUsb0JBQW9CO1NBQ3BDO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsT0FBTztZQUNiLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsUUFBUTtZQUNkLFdBQVcsRUFBRSxhQUFhO1NBQzdCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsV0FBVztZQUNqQixXQUFXLEVBQUUsT0FBTztTQUN2QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLGlCQUFpQjtZQUN2QixXQUFXLEVBQUUsT0FBTztTQUN2QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLGtCQUFrQjtZQUN4QixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFNBQVM7WUFDZixXQUFXLEVBQUUsT0FBTztTQUN2QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFdBQVc7WUFDakIsV0FBVyxFQUFFLE9BQU87U0FDdkI7UUFDRDtZQUNJLElBQUksRUFBRSxTQUFTO1lBQ2YsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxRQUFRO1lBQ2QsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxRQUFRO1lBQ2QsV0FBVyxFQUFFLE9BQU87U0FDdkI7UUFDRDtZQUNJLElBQUksRUFBRSxlQUFlO1lBQ3JCLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsY0FBYztZQUNwQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLGNBQWM7WUFDcEIsV0FBVyxFQUFFLGNBQWM7U0FDOUI7UUFDRDtZQUNJLElBQUksRUFBRSxZQUFZO1lBQ2xCLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsUUFBUTtZQUNkLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsU0FBUztZQUNmLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsUUFBUTtZQUNkLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsTUFBTTtZQUNaLFdBQVcsRUFBRSxPQUFPO1NBQ3ZCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsT0FBTztZQUNiLFdBQVcsRUFBRSxPQUFPO1NBQ3ZCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsY0FBYztZQUNwQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLGdCQUFnQjtZQUN0QixXQUFXLEVBQUUsT0FBTztTQUN2QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLGFBQWE7WUFDbkIsV0FBVyxFQUFFLE9BQU87U0FDdkI7UUFDRDtZQUNJLElBQUksRUFBRSxTQUFTO1lBQ2YsV0FBVyxFQUFFLG9CQUFvQjtTQUNwQztRQUNEO1lBQ0ksSUFBSSxFQUFFLGFBQWE7WUFDbkIsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxVQUFVO1lBQ2hCLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsY0FBYztZQUNwQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFdBQVc7WUFDakIsV0FBVyxFQUFFLGFBQWE7U0FDN0I7UUFDRDtZQUNJLElBQUksRUFBRSxPQUFPO1lBQ2IsV0FBVyxFQUFFLE9BQU87U0FDdkI7UUFDRDtZQUNJLElBQUksRUFBRSxPQUFPO1lBQ2IsV0FBVyxFQUFFLE9BQU87U0FDdkI7UUFDRDtZQUNJLElBQUksRUFBRSxTQUFTO1lBQ2YsV0FBVyxFQUFFLE9BQU87U0FDdkI7UUFDRDtZQUNJLElBQUksRUFBRSxTQUFTO1lBQ2YsV0FBVyxFQUFFLGFBQWE7U0FDN0I7UUFDRDtZQUNJLElBQUksRUFBRSxRQUFRO1lBQ2QsV0FBVyxFQUFFLG9CQUFvQjtTQUNwQztRQUNEO1lBQ0ksSUFBSSxFQUFFLFVBQVU7WUFDaEIsV0FBVyxFQUFFLG9CQUFvQjtTQUNwQztRQUNEO1lBQ0ksSUFBSSxFQUFFLFFBQVE7WUFDZCxXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLGlCQUFpQjtZQUN2QixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFdBQVc7WUFDakIsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxhQUFhO1lBQ25CLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsa0JBQWtCO1lBQ3hCLFdBQVcsRUFBRSxPQUFPO1NBQ3ZCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsVUFBVTtZQUNoQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFFBQVE7WUFDZCxXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLE1BQU07WUFDWixXQUFXLEVBQUUsYUFBYTtTQUM3QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFNBQVM7WUFDZixXQUFXLEVBQUUsYUFBYTtTQUM3QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFNBQVM7WUFDZixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFFBQVE7WUFDZCxXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFNBQVM7WUFDZixXQUFXLEVBQUUsT0FBTztTQUN2QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFFBQVE7WUFDZCxXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFdBQVc7WUFDakIsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxjQUFjO1lBQ3BCLFdBQVcsRUFBRSxvQkFBb0I7U0FDcEM7UUFDRDtZQUNJLElBQUksRUFBRSxRQUFRO1lBQ2QsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxtQkFBbUI7WUFDekIsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxPQUFPO1lBQ2IsV0FBVyxFQUFFLG9CQUFvQjtTQUNwQztRQUNEO1lBQ0ksSUFBSSxFQUFFLE9BQU87WUFDYixXQUFXLEVBQUUsT0FBTztTQUN2QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFFBQVE7WUFDZCxXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFNBQVM7WUFDZixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFNBQVM7WUFDZixXQUFXLEVBQUUsb0JBQW9CO1NBQ3BDO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsWUFBWTtZQUNsQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLE9BQU87WUFDYixXQUFXLEVBQUUsT0FBTztTQUN2QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLGtCQUFrQjtZQUN4QixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFdBQVc7WUFDakIsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxXQUFXO1lBQ2pCLFdBQVcsRUFBRSxhQUFhO1NBQzdCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsZUFBZTtZQUNyQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLE9BQU87WUFDYixXQUFXLEVBQUUsY0FBYztTQUM5QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLHFCQUFxQjtZQUMzQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFVBQVU7WUFDaEIsV0FBVyxFQUFFLE9BQU87U0FDdkI7UUFDRDtZQUNJLElBQUksRUFBRSxVQUFVO1lBQ2hCLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsT0FBTztZQUNiLFdBQVcsRUFBRSxvQkFBb0I7U0FDcEM7UUFDRDtZQUNJLElBQUksRUFBRSxTQUFTO1lBQ2YsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxjQUFjO1lBQ3BCLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsUUFBUTtZQUNkLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsU0FBUztZQUNmLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsUUFBUTtZQUNkLFdBQVcsRUFBRSxhQUFhO1NBQzdCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsU0FBUztZQUNmLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsU0FBUztZQUNmLFdBQVcsRUFBRSxPQUFPO1NBQ3ZCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsVUFBVTtZQUNoQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLGdCQUFnQjtZQUN0QixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFVBQVU7WUFDaEIsV0FBVyxFQUFFLG9CQUFvQjtTQUNwQztRQUNEO1lBQ0ksSUFBSSxFQUFFLHNCQUFzQjtZQUM1QixXQUFXLEVBQUUsT0FBTztTQUN2QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFVBQVU7WUFDaEIsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxVQUFVO1lBQ2hCLFdBQVcsRUFBRSxPQUFPO1NBQ3ZCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsT0FBTztZQUNiLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsU0FBUztZQUNmLFdBQVcsRUFBRSxPQUFPO1NBQ3ZCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsT0FBTztZQUNiLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsU0FBUztZQUNmLFdBQVcsRUFBRSxPQUFPO1NBQ3ZCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsV0FBVztZQUNqQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFVBQVU7WUFDaEIsV0FBVyxFQUFFLE9BQU87U0FDdkI7UUFDRDtZQUNJLElBQUksRUFBRSxVQUFVO1lBQ2hCLFdBQVcsRUFBRSxPQUFPO1NBQ3ZCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsT0FBTztZQUNiLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsUUFBUTtZQUNkLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsT0FBTztZQUNiLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsZUFBZTtZQUNyQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFNBQVM7WUFDZixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFdBQVc7WUFDakIsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxjQUFjO1lBQ3BCLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsY0FBYztZQUNwQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLE9BQU87WUFDYixXQUFXLEVBQUUsYUFBYTtTQUM3QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFVBQVU7WUFDaEIsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxRQUFRO1lBQ2QsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxjQUFjO1lBQ3BCLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsT0FBTztZQUNiLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsV0FBVztZQUNqQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLE1BQU07WUFDWixXQUFXLEVBQUUsT0FBTztTQUN2QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFFBQVE7WUFDZCxXQUFXLEVBQUUsYUFBYTtTQUM3QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFFBQVE7WUFDZCxXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLE1BQU07WUFDWixXQUFXLEVBQUUsT0FBTztTQUN2QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFFBQVE7WUFDZCxXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFdBQVc7WUFDakIsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxZQUFZO1lBQ2xCLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsWUFBWTtZQUNsQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLGVBQWU7WUFDckIsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxXQUFXO1lBQ2pCLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsTUFBTTtZQUNaLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsUUFBUTtZQUNkLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsa0JBQWtCO1lBQ3hCLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsVUFBVTtZQUNoQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLGVBQWU7WUFDckIsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxXQUFXO1lBQ2pCLFdBQVcsRUFBRSxPQUFPO1NBQ3ZCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsV0FBVztZQUNqQixXQUFXLEVBQUUsV0FBVztTQUMzQjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFdBQVc7WUFDakIsV0FBVyxFQUFFLE9BQU87U0FDdkI7UUFDRDtZQUNJLElBQUksRUFBRSxPQUFPO1lBQ2IsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxVQUFVO1lBQ2hCLFdBQVcsRUFBRSxPQUFPO1NBQ3ZCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsT0FBTztZQUNiLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsVUFBVTtZQUNoQixXQUFXLEVBQUUsb0JBQW9CO1NBQ3BDO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsUUFBUTtZQUNkLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsVUFBVTtZQUNoQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLGFBQWE7WUFDbkIsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxXQUFXO1lBQ2pCLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsU0FBUztZQUNmLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsU0FBUztZQUNmLFdBQVcsRUFBRSxvQkFBb0I7U0FDcEM7UUFDRDtZQUNJLElBQUksRUFBRSxPQUFPO1lBQ2IsV0FBVyxFQUFFLG9CQUFvQjtTQUNwQztRQUNEO1lBQ0ksSUFBSSxFQUFFLE1BQU07WUFDWixXQUFXLEVBQUUsT0FBTztTQUN2QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFdBQVc7WUFDakIsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxRQUFRO1lBQ2QsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxRQUFRO1lBQ2QsV0FBVyxFQUFFLGFBQWE7U0FDN0I7UUFDRDtZQUNJLElBQUksRUFBRSxRQUFRO1lBQ2QsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxZQUFZO1lBQ2xCLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsWUFBWTtZQUNsQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLE9BQU87WUFDYixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFFBQVE7WUFDZCxXQUFXLEVBQUUsT0FBTztTQUN2QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFVBQVU7WUFDaEIsV0FBVyxFQUFFLE9BQU87U0FDdkI7UUFDRDtZQUNJLElBQUksRUFBRSxPQUFPO1lBQ2IsV0FBVyxFQUFFLE9BQU87U0FDdkI7UUFDRDtZQUNJLElBQUksRUFBRSxlQUFlO1lBQ3JCLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsUUFBUTtZQUNkLFdBQVcsRUFBRSxPQUFPO1NBQ3ZCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsWUFBWTtZQUNsQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFVBQVU7WUFDaEIsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxpQ0FBaUM7WUFDdkMsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxRQUFRO1lBQ2QsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxXQUFXO1lBQ2pCLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsWUFBWTtZQUNsQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFVBQVU7WUFDaEIsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxVQUFVO1lBQ2hCLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsYUFBYTtZQUNuQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFdBQVc7WUFDakIsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxLQUFLO1lBQ1gsV0FBVyxFQUFFLG9CQUFvQjtTQUNwQztRQUNEO1lBQ0ksSUFBSSxFQUFFLFVBQVU7WUFDaEIsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxPQUFPO1lBQ2IsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxRQUFRO1lBQ2QsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxPQUFPO1lBQ2IsV0FBVyxFQUFFLE9BQU87U0FDdkI7UUFDRDtZQUNJLElBQUksRUFBRSxZQUFZO1lBQ2xCLFdBQVcsRUFBRSxPQUFPO1NBQ3ZCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsUUFBUTtZQUNkLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsa0JBQWtCO1lBQ3hCLFdBQVcsRUFBRSxvQkFBb0I7U0FDcEM7UUFDRDtZQUNJLElBQUksRUFBRSxpQkFBaUI7WUFDdkIsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxZQUFZO1lBQ2xCLFdBQVcsRUFBRSxhQUFhO1NBQzdCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsTUFBTTtZQUNaLFdBQVcsRUFBRSxPQUFPO1NBQ3ZCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsV0FBVztZQUNqQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLE9BQU87WUFDYixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFlBQVk7WUFDbEIsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxPQUFPO1lBQ2IsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxNQUFNO1lBQ1osV0FBVyxFQUFFLE9BQU87U0FDdkI7UUFDRDtZQUNJLElBQUksRUFBRSxRQUFRO1lBQ2QsV0FBVyxFQUFFLGFBQWE7U0FDN0I7UUFDRDtZQUNJLElBQUksRUFBRSxTQUFTO1lBQ2YsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxhQUFhO1lBQ25CLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsTUFBTTtZQUNaLFdBQVcsRUFBRSxPQUFPO1NBQ3ZCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsa0JBQWtCO1lBQ3hCLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsaUJBQWlCO1lBQ3ZCLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsU0FBUztZQUNmLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsYUFBYTtZQUNuQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFVBQVU7WUFDaEIsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxXQUFXO1lBQ2pCLFdBQVcsRUFBRSxvQkFBb0I7U0FDcEM7UUFDRDtZQUNJLElBQUksRUFBRSxRQUFRO1lBQ2QsV0FBVyxFQUFFLGFBQWE7U0FDN0I7UUFDRDtZQUNJLElBQUksRUFBRSxTQUFTO1lBQ2YsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxpQkFBaUI7WUFDdkIsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxVQUFVO1lBQ2hCLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsWUFBWTtZQUNsQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFdBQVc7WUFDakIsV0FBVyxFQUFFLE9BQU87U0FDdkI7UUFDRDtZQUNJLElBQUksRUFBRSxTQUFTO1lBQ2YsV0FBVyxFQUFFLGNBQWM7U0FDOUI7UUFDRDtZQUNJLElBQUksRUFBRSxPQUFPO1lBQ2IsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxTQUFTO1lBQ2YsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxNQUFNO1lBQ1osV0FBVyxFQUFFLE9BQU87U0FDdkI7UUFDRDtZQUNJLElBQUksRUFBRSxTQUFTO1lBQ2YsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxTQUFTO1lBQ2YsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxZQUFZO1lBQ2xCLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsTUFBTTtZQUNaLFdBQVcsRUFBRSxhQUFhO1NBQzdCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsV0FBVztZQUNqQixXQUFXLEVBQUUsb0JBQW9CO1NBQ3BDO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsVUFBVTtZQUNoQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLE9BQU87WUFDYixXQUFXLEVBQUUsb0JBQW9CO1NBQ3BDO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsWUFBWTtZQUNsQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLGNBQWM7WUFDcEIsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxPQUFPO1lBQ2IsV0FBVyxFQUFFLE9BQU87U0FDdkI7UUFDRDtZQUNJLElBQUksRUFBRSxZQUFZO1lBQ2xCLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsYUFBYTtZQUNuQixXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFVBQVU7WUFDaEIsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxVQUFVO1lBQ2hCLFdBQVcsRUFBRSxvQkFBb0I7U0FDcEM7UUFDRDtZQUNJLElBQUksRUFBRSxRQUFRO1lBQ2QsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxPQUFPO1lBQ2IsV0FBVyxFQUFFLG9CQUFvQjtTQUNwQztRQUNEO1lBQ0ksSUFBSSxFQUFFLGVBQWU7WUFDckIsV0FBVyxFQUFFLFFBQVE7U0FDeEI7UUFDRDtZQUNJLElBQUksRUFBRSxZQUFZO1lBQ2xCLFdBQVcsRUFBRSxvQkFBb0I7U0FDcEM7UUFDRDtZQUNJLElBQUksRUFBRSxjQUFjO1lBQ3BCLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUscUJBQXFCO1lBQzNCLFdBQVcsRUFBRSxvQkFBb0I7U0FDcEM7UUFDRDtZQUNJLElBQUksRUFBRSxlQUFlO1lBQ3JCLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsV0FBVztZQUNqQixXQUFXLEVBQUUsT0FBTztTQUN2QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLGtCQUFrQjtZQUN4QixXQUFXLEVBQUUsT0FBTztTQUN2QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLGNBQWM7WUFDcEIsV0FBVyxFQUFFLE9BQU87U0FDdkI7UUFDRDtZQUNJLElBQUksRUFBRSxVQUFVO1lBQ2hCLFdBQVcsRUFBRSxvQkFBb0I7U0FDcEM7UUFDRDtZQUNJLElBQUksRUFBRSxlQUFlO1lBQ3JCLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO0tBQ0o7Q0FDSixDQUFBIn0=